var map = {
	"./da.json": 31677,
	"./de.json": 56985,
	"./en.json": 29323,
	"./es-ES.json": 7562,
	"./es.json": 80673,
	"./fr.json": 25455,
	"./it.json": 11755,
	"./ja.json": 23716,
	"./lang.json": 21575,
	"./nl.json": 54022,
	"./no.json": 86974,
	"./pt.json": 15235,
	"./ru.json": 32239,
	"./yy.json": 5836,
	"./zh-CN.json": 15064
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(id => {
		return __webpack_require__.t(id, 3);
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 10270;
module.exports = webpackAsyncContext;